import React, { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
}

interface CardSubcomponentProps {
  children: ReactNode;
}

const Card: React.FC<CardProps> & {
  Header: React.FC<CardSubcomponentProps>;
  Content: React.FC<CardSubcomponentProps>;
  Footer: React.FC<CardSubcomponentProps>;
} = ({ children, className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="bg-white rounded-lg shadow-md w-full flex flex-col">
        {/* Content - scrollable if needed */}
        <div className="flex-1">{children}</div>
      </div>
    </div>
  );
};

const CardHeader: React.FC<CardSubcomponentProps> = ({ children }) => {
  return (
    <div className="z-10 px-6 py-4 border-b border-gray-200 flex justify-end gap-3 bg-white rounded-t-lg top-0 text-gray-700">
      {children}
    </div>
  );
};

const CardContent: React.FC<CardSubcomponentProps> = ({ children }) => {
  return (
    <div className="px-6 py-4 flex flex-col text-gray-600 max-h-[60vh] sm:max-h-[40vh] overflow-y-auto">
      {children}
    </div>
  );
};

const CardFooter: React.FC<CardSubcomponentProps> = ({ children }) => {
  return (
    <div className="z-10 px-6 py-4 border-t border-gray-200 bg-white rounded-b-lg bottom-0">
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;

export { Card };
